import { TableCell, TableSortLabel } from "@mui/material"
import type { SystemStyleObject } from "@mui/system"
import type { Theme } from "@mui/material"
import type React from "react"
import { extraColors } from "../../utils/theme"

export interface NwssSortableTableHeaderProps {
  label: string
  active: boolean
  order: "asc" | "desc"
  onClick: () => void
  align?: "left" | "right" | "center"
  cellSx?: SystemStyleObject<Theme>
}

export const NwssSortableTableHeader: React.FC<
  NwssSortableTableHeaderProps
> = ({ label, active, order, onClick, align = "left", cellSx }) => (
  <TableCell align={align} sx={{ color: extraColors.translucent50, ...cellSx }}>
    <TableSortLabel
      active={active}
      direction={active ? order : "asc"}
      onClick={onClick}
      sx={{
        color: `${extraColors.translucent50} !important`,
        "&.Mui-active": { color: `${extraColors.white} !important` },
        "& .MuiTableSortLabel-icon": {
          color: `${extraColors.white} !important`,
        },
        ...(align === "right"
          ? {
              flexDirection: "row-reverse",
              "& .MuiTableSortLabel-icon": {
                marginLeft: 0,
                marginRight: 4,
              },
            }
          : align === "center"
            ? {
                width: "100%",
                justifyContent: "center",
              }
            : {}),
      }}
    >
      {label}
    </TableSortLabel>
  </TableCell>
)
